{
  "name": "User",
  "columns": [
    {
      "fieldName": "name",
      "dbName": "name",
      "displayName": "Name",
      "dataType": "STRING"
    },
    {
      "fieldName": "email",
      "dbName": "email",
      "displayName": "Email",
      "dataType": "STRING"
    },
    {
      "fieldName": "username",
      "dbName": "username",
      "displayName": "Username",
      "dataType": "STRING"
    },
    {
      "fieldName": "mobile",
      "dbName": "mobile",
      "displayName": "Mobile",
      "dataType": "STRING"
    },
    {
      "fieldName": "active",
      "dbName": "active",
      "displayName": "Status",
      "dataType": "BOOLEAN",
      "valueMap": {
        "true": "Active",
        "false": "Inactive"
      },
      "thStyleConfig": {
        "width": "70px"
      },
      "styleConfig": {
        "type": "status"
      }
    },
    {
      "fieldName": "locked",
      "dbName": "locked",
      "displayName": "Locked",
      "dataType": "BOOLEAN",
      "thStyleConfig": {
        "width": "55px"
      },
      "styleConfig": {
        "type": "badge",
        "iconPosition": "left",
        "conditions": [
          {
            "expression": "eq(value, 'true')",
            "icon": "assets/icons/locktable.svg",
            "styleProperties": {
              "display": "flex",
              "padding": "2px 8px 2px 6px",
              "alignItems": "center",
              "gap": "4px",
              "borderRadius": "16px",
              "border": "1px solid var(--Success-200, #ABEFC6)",
              "background": "var(--Success-50, #ECFDF3)",
              "color": "var(--Success-700, #067647)",
              "textAlign": "center",
              "fontFamily": "Inter",
              "fontSize": "12px",
              "fontStyle": "normal",
              "fontWeight": "500",
              "lineHeight": "18px"
            },
            "iconStyleProperties": {
              "width": "12px",
              "height": "12px",
              "background": "#079455"
            }
          },
          {
            "expression": "eq(value, 'false')",
            "icon": "assets/icons/unlockedtable.svg",
            "styleProperties": {
              "display": "flex",
              "padding": "2px 8px 2px 6px",
              "alignItems": "center",
              "gap": "4px",
              "borderRadius": "16px",
              "border": "1px solid var(--Gray-200, #E4E7EC)",
              "background": "var(--Gray-50, #F9FAFB)",
              "color": "var(--Gray-700, #344054)",
              "textAlign": "center",
              "fontFamily": "Inter",
              "fontSize": "12px",
              "fontStyle": "normal",
              "fontWeight": "500",
              "lineHeight": "18px"
            },
            "iconStyleProperties": {
              "width": "12px",
              "height": "12px",
              "background": "#000000"
            }
          }
        ]
      }
    },
    {
      "fieldName": "roles",
      "dbName": "roles",
      "displayName": "Roles",
      "dataType": "ARRAY",
      "styleConfig": {
        "type": "multi-tag"
      }
    },
    {
      "fieldName": "modifiedBy",
      "dbName": "modified_by",
      "displayName": "Modified By",
      "dataType": "STRING",
      "styleConfig": {
        "type": "user-avatar"
      }
    },
    {
      "fieldName": "modifiedDate",
      "dbName": "modified_date",
      "displayName": "Modified Date",
      "dataType": "DATETIME",
      "sortable": true
    }
  ]
}
